module.exports = __webpack_public_path__ + "static/media/menuGift.49f5925f.svg";